module.exports = __webpack_public_path__ + "img/f1.0a8c9ebb.png";